import { useState, useEffect, Fragment, useRef } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import ClientForm from "./ClientForm";
import InputCombo from "../../helpers/InputCombo";
import ClientReview from "./ClientReview";
import DialogServices from "./DialogServices";
import InputServicesMulti from "../../helpers/InputServicesMulti";
import ContractForm from "./ContractForm";
import ContractReview from "./ContractReview";



import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Xlsx from "../../exporter/Xlsx";


function Contracts(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    var defId = -1;
    if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   

        fak_kontrahenci_id:  defId,   

        nazwa:  props.mainView.readFilter('cntr_nazwa',''),   
        nip:  props.mainView.readFilter('cntr_nip',''),   
        sl_typ_uslugi_id:  props.mainView.readFilter('cntr_sl_typ_uslugi_id',''),   
        stan_umowy:  props.mainView.readFilter('cntr_stan_umowy','_x_'),   

        services:  props.mainView.readFilter('cntr_services',''),   
        no_services:  props.mainView.readFilter('cntr_no_services',''),   
        wg_inflacji:  props.mainView.readFilter('cntr_wg_inflacji','_x_'),   

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    
    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);

    const [services, setServices] = useState([]);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([        
        {
            cls:'color_deleted',
            title: 'umowa nieaktywna',
            filter: {  filed: "stan_umowy", set: "2", typ: "combo"  },
        },
    ]);




        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 5000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

            props.mainView.writeFilter('cntr_nazwa', '');
            props.mainView.writeFilter('cntr_nip', '');
            props.mainView.writeFilter('cntr_sl_typ_uslugi_id', '');
            props.mainView.writeFilter('cntr_stan_umowy', '_x_');
            props.mainView.writeFilter('cntr_services', '');
            props.mainView.writeFilter('cntr_no_services', '');
            props.mainView.writeFilter('cntr_wg_inflacji', '_x_');
           

            setFilterParam({

                fak_kontrahenci_id:  defId,  

                nazwa: '',                 
                nip: '',                 
                sl_typ_uslugi_id: '',                 
                stan_umowy: '_x_',                 
                services: '',                 
                no_services: '',                 
                wg_inflacji: '_x_',                 
                
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }




        
    const remove = (e) => {

        var title = e.target.getAttribute('atr-title');
        var id = e.target.getAttribute('atr-id');

        props.mainView.showDialog( "Potwierdź", "Czy na pewno chcesz usunąć umowę "+title+"" , "yesno" ,  (res)=>{

                    if(res == "yes")
                    {
                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                        

                                
                                 props.mainView.showProgress();       
                    

                                    fetch( Config.url + '/rest_v1_home,contract_remove', {
                                        method: 'POST', 
                                        body: JSON.stringify({
                                            id: id,
                                        }), 
                                        headers: {
                                            'Content-Type': 'application/json',                    
                                            'X-Api-Key': props.userData.apiKey,
                                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                            '_sec_key_': Config.genXKey() ,
                                        }
                                    })
                                    .then(res => res.json() )
                                    .then(res => { 

                                            props.mainView.hideProgress();    

                                                if(res._sys_ == undefined)
                                                {
                                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                }else
                                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                {
                                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                }else    
                                                {
                                                    if(res.status == 'OK')         
                                                    {       
                                                        setTab(null);//pobierz na nowo        
                                                        props.mainView.showDialog( "Sukces", "Umowa została usunięte"  , "ok" , null);                             
                                                    }else 
                                                    {
                                                        props.mainView.showDialog( "Ups!", "Nie można usunać dokumentu " + res.result , "error" , null);
                                                    }
                                                }
                                    } )
                                    .catch(err => {          
                                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                            props.mainView.hideProgress();    
                                    });

                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                    }


        } );


    }



    const getTab = () => {
        
      
       props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_home,contracts', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }




        const getTServices = () => {
        

        props.mainView.showProgress();
        

        fetch( Config.url + '/rest_v1_home,t_services', {
            method: 'POST', 
            body: JSON.stringify({all:1}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setServices(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }



    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }


      const onAdded = ( newId ) => {                
        setView({...view, ["v"]:"review", ["id"]:newId });              
    }

    

    const keyListener = (e) => {

                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                            e.target.blur();
                            filterClear();
                        }   else                        
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                           filterClear();
                        } else                                                                    
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                            setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                            setTab(null);
                        } else                                            
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                               props.keyListener(e);
                        }

    }


   useEffect( ()=>{

            if(Config.env == "dev") console.log("Contract.js, listener on");
            window.onkeydown = keyListener;                    
            
            return () => {   
                 if(Config.env == "dev") console.log("Contract.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );


    




    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        filterClear();
        setTab(null);
        getTServices();
    }



    if(tab == null)
    {
        setTab([]);
        getTab();    
        getTServices(); 
        return <div>
            ...
        </div>
    }





 



    if(view.v == "new")
    {
        return <ContractForm userData={props.userData} mainView={props.mainView}  keyListener={keyListener} onBack={onBack} onSuccess={onSuccess} onAdded={onAdded}   id={-1}  fak_kontrahenci_id={filterParam.fak_kontrahenci_id} />
    }
 
    if(view.v == "edit")
    {
        return <ContractForm userData={props.userData} mainView={props.mainView}  keyListener={keyListener} onBack={onBack} onSuccess={onSuccess}  id={view.id} fak_kontrahenci_id={filterParam.fak_kontrahenci_id} />
    }

    if(view.v == "review")
    {
        return <ContractReview userData={props.userData} mainView={props.mainView}  keyListener={keyListener} onBack={onBack} onSuccess={onSuccess}  id={view.id} fak_kontrahenci_id={filterParam.fak_kontrahenci_id} />
    }





 
        var sortList = [                
        {column: "data_zawarcia", name: "Data zawarcia"  },         
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "firma_nazwa", name: "Nazwa firmy"  },
]


        document.title = "Lista umów" ;


        var titleRaport = "Umowy";

    return  <div className="view_content">


                    {
                        filterParam.fak_kontrahenci_id < 0 &&
                        <h3 className="dash_header">Umowy</h3>
                    }                

    
               <div className="table_filter">

                        {
                            filterParam.fak_kontrahenci_id < 0 &&
                            <Fragment>
                                   

                                    <div className="filter_controll">   
                                            <label>Nazwa: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />
                                    </div> 

                                    <div className="filter_controll">   
                                            <label>NIP: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.nip}   valChange={valChangeListener} goNext={goNextNew} name="nip" placeholder={"NIP: "}   />
                                    </div> 

                                    <div className="filter_controll">   
                                            <label>Typ klienta: </label>                             
                                            <InputCombo items={services}   userData={props.userData} value={filterParam.sl_typ_uslugi_id}   valChange={valChangeListener} goNext={goNextNew} name="sl_typ_uslugi_id" placeholder={": "}   />
                                    </div> 
                            </Fragment>
                        }
                       



                        <div className="filter_controll">   
                                <label>Status umowy: </label>                             
                                <InputCombo items={ [{v:"_x_",title:'- - - '},{v:"1",title:'Aktywna'}, {v:"2",title:'Nieaktywna'}] }   userData={props.userData} value={filterParam.stan_umowy}   valChange={valChangeListener} goNext={goNextNew} name="stan_umowy" placeholder={": "}   />
                        </div> 


                        <div className="filter_controll">   
                                <label>Zawiera usługi: </label>                             
                                <InputServicesMulti mainView={props.mainView}  userData={props.userData} value={filterParam.services}   valChange={valChangeListener} goNext={goNextNew} name="services" placeholder={": "}   />
                        </div> 

                        <div className="filter_controll">   
                                <label>NIE Zawiera usługi: </label>                             
                                <InputServicesMulti mainView={props.mainView}  userData={props.userData} value={filterParam.no_services}   valChange={valChangeListener} goNext={goNextNew} name="no_services" placeholder={": "}   />
                        </div> 


                        <div className="filter_controll">   
                                <label>Zapis o inflacji: </label>                             
                                <InputCombo items={ [{v:"_x_",title:'- - - '},{v:"1",title:'Tak'}, {v:"0",title:'Nie'}] }   userData={props.userData} value={filterParam.wg_inflacji}   valChange={valChangeListener} goNext={goNextNew} name="wg_inflacji" placeholder={": "}   />
                        </div> 



                        <div className="filter_btn">                       
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div> 
               </div>




                <div className="table_widget">
                              <div className="btn" onClick={changeView} v="new" id="-1"  > nowa umowa [+]</div>

                              &nbsp;&nbsp;
 

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  /> 
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />


                              &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Xlsx tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Print tabRef={tab2Ref}   title={titleRaport} />

                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                </div>


               <div className="bg_center">


                        <div ref={tabRef} className="gohide">
                                    <h3>{titleRaport}</h3> 
                                  <table className="table" ref={tab2Ref} >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                 
                                                <td>Numer umowy</td>                                                                                                                                    
                                                <td>Data zawarcia</td>         
                                                 <td>NIP</td>                                                                                                                                    
                                                <td>Nazwa</td>                                                                                                                             
                                                <td>Usługi</td>                                                                                      
                                                <td className="td_right">Wsk. inflacji</td>    
                                                                                                                    
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            if(row.stan_umowy == '2') rowStyle = rowStyle + " color_deleted ";

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td>{ix+1}</td>                                                          
                                                                <td className="gocenter" v="review" id={row.id} onClick={changeView} >{row.numer_umowy }</td>
                                                                <td className="gocenter">{row.data_zawarcia }</td>
                                                                <td className="gocenter" v="review" id={row.id} onClick={changeView} >{row.klient.nip}</td>
                                                                <td v="review" id={row.id} onClick={changeView}>{row.klient.nazwa}</td>
                                                                <td className="gocenter"> <DialogServices tab={row.uslugi}/> </td>
                                                                <td className="gocenter"> 
                                                                    {
                                                                        row.wg_inflacji == 1 &&
                                                                        <span>Tak ({row.inflacja_typ})</span>
                                                                    }
                                                                    {
                                                                        row.wg_inflacji == 0 &&
                                                                        <span>Nie</span>
                                                                    }
                                                                </td>
                                                            
                                                     
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>
                        </div>


                        <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                 
                                                <td>Numer umowy</td>                                                                                                                                    
                                                <td>Data zawarcia</td>         
                                                {
                                                   props.fak_kontrahenci_id == undefined && 
                                                   <Fragment>
                                                      <td>Nazwa</td>
                                                      <td>NIP</td>
                                                   </Fragment>
                                                }                                                                                                                                                                          
                                                <td>Usługi</td>                                                                                      
                                                <td className="td_right">Wsk. inflacji</td>    
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            if(row.stan_umowy == '2') rowStyle = rowStyle + " color_deleted ";

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td>{ix+1}</td>                                                          
                                                                <td className="gocenter" v="review" id={row.id} onClick={changeView} >{row.numer_umowy }</td>
                                                                <td className="gocenter">{row.data_zawarcia }</td>

                                                                { 
                                                                   props.fak_kontrahenci_id == undefined &&
                                                                   <Fragment>
                                                                        <td className="gocenter" v="review" id={row.id} onClick={changeView} >{row.klient.nip}</td>
                                                                        <td v="review" id={row.id} onClick={changeView}>{row.klient.nazwa}</td>
                                                                   </Fragment>
                                                                } 
                                                                


                                                                <td className="gocenter"> <DialogServices tab={row.uslugi}/> </td>
                                                                <td className="gocenter"> 
                                                                    {
                                                                        row.wg_inflacji == 1 &&
                                                                        <span>Tak ({row.inflacja_typ})</span>
                                                                    }
                                                                    {
                                                                        row.wg_inflacji == 0 &&
                                                                        <span>Nie</span>
                                                                    }
                                                                </td>
                                                                <MenuTable>
                                                                    <ul>
                                                                        <li v="review" id={row.id} onClick={changeView} >Podgląd</li>
                                                                        <li v="edit" id={row.id} onClick={changeView}>Zmień dane</li>
                                                                        <li v="edit" atr-id={row.id} atr-title={row.numer_umowy + " klienta " + row.klient.nazwa } onClick={remove}>Usuń</li>
                                                                    </ul>
                                                                </MenuTable>
                                                     
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>

               </div>
 
              

                              
           

    </div>
}


export default Contracts;